import { Injectable } from '@angular/core';
import {
  PaymentPreviewV1Response,
  SessionPayment,
  TransactionPayableV1,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class PaymentInformationPreviewHelperService {
  syncSummaryPreviewWithPayment(
    preview: PaymentPreviewV1Response,
    payment: SessionPayment,
  ) {
    const paymentPayables: TransactionPayableV1[] = [];
    payment.transactions.forEach((transaction) =>
      paymentPayables.push(...transaction.payables),
    );
    preview.payments.forEach((x) => {
      x.payment.payables.forEach((previewPayable) => {
        const paymentPayable = paymentPayables.find(
          (y) => y.urn === previewPayable.burn,
        );
        const hasAppliedDiscount = paymentPayable?.appliedDiscount ?? 0 !== 0;
        if (hasAppliedDiscount) {
          previewPayable.isDiscountApplied = true;
          previewPayable.availableDiscount = paymentPayable.appliedDiscount;
          previewPayable.appliedDiscount = paymentPayable.appliedDiscount;
          previewPayable.discountExclusionReasons = [];
        }
      });
    });
  }
}
